import React, { createContext, useContext, useState, useRef } from 'react';

// Create a context for the tooltip position
const PopoverContext = createContext();

// Create a provider component to wrap your application and provide the context value
export const PopoverProvider = ({ children }) => {
  const [popoverPosition, setpopoverPosition] = useState({ top: 0, left: 0, popoverId: '' });
  const buttonRef = useRef();

  const setPopoverPosition = (position) => {
   // debugger;
    const element = document.getElementById(position.popoverId);
    if (element?.style) {
      element.style.transform = '';
      element.style.top = position.top + 'px';
      element.style.left = position.left + 'px';
    }
  }

  const updatePopoverPosition = (parent, position, offset, align, widgetName) => {
    //debugger;
    if (parent) {
      const popover = document.getElementById(widgetName);
      buttonRef.current = document.getElementById(parent);
      const editorMain = document.getElementById('pageEditorMainCanvas');
      const buttonRect = buttonRef?.current?.getBoundingClientRect();
      const scrollLeft = editorMain?.scrollLeft;
      const scrollTop = editorMain?.scrollTop;
      const scrollBottom = editorMain?.scrollBottom;
      const mainRect = editorMain?.getBoundingClientRect();
      const popoverRect = popover?.getBoundingClientRect();
      const popoverLeft = (buttonRect?.right + scrollLeft) - mainRect?.left;
      const popoverTop = (buttonRect?.top + scrollTop) - mainRect?.top;
      if (position == 'Right') {
        if (align == 'top') {
          setPopoverPosition({
            top: (buttonRect?.top + scrollTop) - mainRect?.top,
            left: popoverLeft + parseFloat(offset),
            popoverId: widgetName
          });
        }
        else if (align == 'bottom') {
          setPopoverPosition({
            top: (buttonRect?.bottom + scrollTop) - mainRect?.top - popoverRect?.height,
            left: popoverLeft + parseFloat(offset),
            popoverId: widgetName
          });
        }
        else {
          setPopoverPosition({
            top: (buttonRect?.bottom + scrollTop) - mainRect?.top - (popoverRect?.height / 2) - (buttonRect?.height / 2),
            left: popoverLeft + parseFloat(offset),
            popoverId: widgetName
          });
        }
      }
      else if (position == 'Left') {
        if (align == 'top') {
          setPopoverPosition({
            top: (buttonRect?.top + scrollTop) - mainRect?.top,
            left: popoverLeft - parseFloat(offset) - popoverRect?.width - buttonRect?.width,
            popoverId: widgetName
          });
        }
       else if (align == 'bottom') {
          setPopoverPosition({
            top: (buttonRect?.bottom + scrollTop) - mainRect?.top - popoverRect?.height,
            left: popoverLeft - parseFloat(offset) - popoverRect?.width - buttonRect?.width,
            popoverId: widgetName
          });
        }
        else {
          setPopoverPosition({
            top: (buttonRect?.bottom + scrollTop) - mainRect?.top - (popoverRect?.height / 2) - (buttonRect?.height / 2),
            left: popoverLeft - parseFloat(offset) - popoverRect?.width - buttonRect?.width,
            popoverId: widgetName
          });
        }
      }
      else if (position == 'Top') {
        if (align == 'left') {
          setPopoverPosition({
            top: popoverTop - parseFloat(offset) - popoverRect?.height,
            left: popoverLeft - buttonRect?.width,
            popoverId: widgetName
          });
        }
        else if (align == 'right') {
          setPopoverPosition({
            top: popoverTop - parseFloat(offset) - popoverRect?.height,
            left: popoverLeft - popoverRect?.width,
            popoverId: widgetName
          });
        }
        else {
          setPopoverPosition({
            top: popoverTop - parseFloat(offset) - popoverRect?.height,
            left: popoverLeft - (buttonRect?.width / 2) - (popoverRect?.width / 2),
            popoverId: widgetName
          });
        }
      }
      else {
        if (align == 'left') {
          setPopoverPosition({
            top: popoverTop + parseFloat(offset) + buttonRect?.height,
            left: popoverLeft - buttonRect?.width,
            popoverId: widgetName
          });
        }
        else if (align == 'right') {
          setPopoverPosition({
            top: popoverTop + parseFloat(offset) + buttonRect?.height,
            left: popoverLeft - popoverRect?.width,
            popoverId: widgetName
          });
        }
        else {
          setPopoverPosition({
            top: popoverTop + parseFloat(offset) + buttonRect?.height,
            left: popoverLeft - (buttonRect?.width / 2) - (popoverRect?.width / 2),
            popoverId: widgetName
          });
        }
      }
    }
  };

  return (
    <PopoverContext.Provider value={{ popoverPosition, updatePopoverPosition }}>
      {children}
    </PopoverContext.Provider>
  );
};

// Custom hook to access the tooltip context
export const usePopover = () => {
  const context = useContext(PopoverContext);
  if (!context) {
    throw new Error('useTooltip must be used within a TooltipProvider');
  }
  return context;
};